
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/[slugOrCompany]",
      function () {
        return require("private-next-pages/guides/[slugOrCompany]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/[slugOrCompany]"])
      });
    }
  